"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROLE_ID = void 0;
var ROLE_ID = {
  ADMIN: 'c8679461-9bac-4210-bc65-387708396fef'
};
exports.ROLE_ID = ROLE_ID;